import { Steps, Card, Typography, Button, Space, Tag } from 'antd';
import {
  DownloadOutlined,
  SettingOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

interface SetupWizardProps {
  agentStatus: 'online' | 'offline';
  licenseKey?: string;
}

export function SetupWizard({ agentStatus, licenseKey }: SetupWizardProps) {
  const isAgentOnline = agentStatus === 'online';
  const currentStep = isAgentOnline ? 2 : 0;

  if (isAgentOnline) return null;

  return (
    <Card style={{ marginBottom: 24 }}>
      <Title level={4}>Agent Kurulumu</Title>
      <Paragraph type="secondary">
        Raporlarınızı görebilmek için agent yazılımını sunucunuza kurmanız gerekmektedir.
      </Paragraph>

      <Steps
        current={currentStep}
        direction="vertical"
        items={[
          {
            title: 'Agent İndir',
            description: (
              <Space direction="vertical" size="small">
                <Text>Agent kurulum dosyasını indirin.</Text>
                <Button type="primary" icon={<DownloadOutlined />} href="/api/v2/agent/download/latest">
                  Agent İndir
                </Button>
              </Space>
            ),
            icon: <DownloadOutlined />,
          },
          {
            title: 'Kurulumu Tamamla',
            description: (
              <Space direction="vertical" size="small">
                <Text>Kurulum sırasında aşağıdaki bilgileri girin:</Text>
                <Text>
                  <strong>Lisans Anahtarı:</strong>{' '}
                  {licenseKey ? <Text code copyable>{licenseKey}</Text> : <Tag>Kayıt ekranında verildi</Tag>}
                </Text>
                <Text>
                  <strong>Veritabanı Bağlantısı:</strong> SQL Server veya Firebird bağlantı bilgileriniz
                </Text>
              </Space>
            ),
            icon: <SettingOutlined />,
          },
          {
            title: 'Bağlantı Kontrolü',
            description: (
              <Space>
                {isAgentOnline ? (
                  <Tag icon={<CheckCircleOutlined />} color="success">Agent Bağlı</Tag>
                ) : (
                  <Tag icon={<CloseCircleOutlined />} color="error">Agent Bağlı Değil</Tag>
                )}
              </Space>
            ),
            icon: isAgentOnline ? <CheckCircleOutlined /> : <CloseCircleOutlined />,
          },
        ]}
      />
    </Card>
  );
}
